module.exports = __webpack_public_path__ + "img/logo.2d32b749.png";